/**
 * Curated Instagram posts shown on the homepage.
 * Paste full post / reel URLs, e.g.:
 *   "https://www.instagram.com/p/XXXXXXXXXXX/"
 *   "https://www.instagram.com/reel/YYYYYYYYYYY/"
 */
export const INSTAGRAM_POSTS: string[] = [
  "https://www.instagram.com/p/DYetsxTRkfd/",
  "https://www.instagram.com/p/DTIVViRkaw-/",
  "https://www.instagram.com/p/DXDZfrlET-6/",
];